import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { fetchPublicPolicies, policyPath, PUBLIC_POLICIES_KEY } from '@/features/legal/api/policies';

/**
 * The published policies, as a row of links in the marketing footer.
 *
 * Read from the API like everything else about policies, so publishing the
 * cookie policy puts it in the footer without a deploy. Nothing renders
 * while the list loads or if it cannot be had.
 */
export function PolicyFooterLinks() {
  const policies = useQuery({
    queryKey: PUBLIC_POLICIES_KEY,
    queryFn: fetchPublicPolicies,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const items = policies.data ?? [];
  if (items.length === 0) return null;

  return (
    <nav aria-label="Legal">
      <ul className="flex flex-wrap justify-center gap-x-5 gap-y-1.5">
        {items.map((item) => (
          <li key={item.slug}>
            <Link
              to={policyPath(item.slug)}
              className="text-xs text-muted transition-colors hover:text-brand-600"
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
